import { render, staticRenderFns } from "./InstructorRegister.vue?vue&type=template&id=44911a34&scoped=true"
import script from "./InstructorRegister.vue?vue&type=script&lang=js"
export * from "./InstructorRegister.vue?vue&type=script&lang=js"
import style0 from "./InstructorRegister.vue?vue&type=style&index=0&id=44911a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44911a34",
  null
  
)

export default component.exports